import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'
import { TimelineEntryIcons } from './TimelineIcons'
import { useTw } from '../../../../../../../../utils/Styles'
import { localizeString } from '../../../../../../../../utils'
import { StatusPageQuery } from '../../../../StatusPage.generated'

type Props = {
  event: StatusPageQuery['Profile']['statusPage']['components'][0]['eventsHistory'][0]['events'][0]
}

export function Timeline({ event }: Props) {
  const tw = useTw()
  const { t } = useTranslation('common')

  return (
    <div className={tw`flow-root relative`}>
      <span
        aria-hidden="true"
        className={tw`absolute top-0 left-4 -ml-px h-full w-0.5 bg-gray-200 block`}
      />
      <ul role="list" className={tw`space-y-8`}>
        {event.historyItems.map((historyItem) => (
          <li key={historyItem._id}>
            <div className={tw`relative flex space-x-3`}>
              <div className={tw`relative z-10`}>
                <TimelineEntryIcons status={historyItem.status} />
              </div>
              <div className={tw`min-w-0 w-full -mt-1 flex flex-col space-y-4`}>
                <div>
                  <p className={tw`text-gray-800`}>
                    {t(
                      `status_page.transfer_statuses.incident.${historyItem.status}`
                    )}
                  </p>
                  <p className={tw`text-sm text-gray-500`}>
                    <time dateTime={historyItem.eventDate}>
                      {DateTime.fromISO(historyItem.eventDate).toLocaleString(
                        DateTime.DATETIME_SHORT
                      )}
                    </time>
                  </p>
                </div>
                <div className={tw`text-sm`}>
                  <p>{localizeString(historyItem.message)}</p>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
